import { createSelector } from 'reselect';

import { get as _get } from 'lodash';

import { selectFirestore } from 'services/selectors';

const selectState = state => state.imports;

export const selectPendingFactory = includes =>
    createSelector(selectFirestore, firestore => {
        const requesting = _get(firestore, 'status.requesting', {});
        const requested = _get(firestore, 'status.requested', {});
        const key = Object.keys(requesting).find(k => k.includes(includes));
        return key && requesting[key] && !requested[key];
    });

export const selectLastImportPending = selectPendingFactory('imports?limit=1');
export const selectLogsPending = selectPendingFactory('logs');

export const selectLastImport = createSelector(selectFirestore, firestore =>
    _get(firestore, 'ordered.lastImport.0', null),
);

export const selectImportInProcessFlag = createSelector(selectState, imports => imports.importInProcess);

export const selectImportDetail = createSelector(
    selectLastImport,
    selectImportInProcessFlag,
    (lastImport, importInProcess) =>
        lastImport
            ? {
                  id: lastImport.id,
                  startAt: lastImport.startAt ? lastImport.startAt.toDate() : null,
                  endAt: lastImport.endAt ? lastImport.endAt.toDate() : null,
                  importInProcess,
              }
            : null,
);

export const selectLogs = createSelector(selectFirestore, firestore =>
    _get(firestore, 'ordered.logs', []).map(log => ({
        ...log,
        timestamp: log.timestamp.toDate(),
    })),
);
